export const LANG = {
  PORTUGUESE: "pt_BR",
};
